import _ from 'lodash';
import { getField, updateField } from 'vuex-map-fields';
const state = {
    _id: null,
    format_date: null,
    step: 'perfilar',
    creditos: []
};
const mutations = {
    updateField,
    updateStep: (state, payload) =>{
        state.step = payload;
    },
    updatePanel: (state, payload) =>{
        state._id = payload._id;
        state.format_date = payload.format_date;
    },
    updateCreditos: (state, payload) => {
        state.creditos = payload;
    }
};

const getters = {
    getField
};
export default {
    namespaced: true,
    state,
    mutations,
    getters
}
